module.exports = __webpack_public_path__ + "img/question-icon.54b94ad7.svg";